import { render, staticRenderFns } from "./ArchiveProject.vue?vue&type=template&id=0c6b3642&scoped=true&"
import script from "./ArchiveProject.vue?vue&type=script&lang=js&"
export * from "./ArchiveProject.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveProject.vue?vue&type=style&index=0&id=0c6b3642&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6b3642",
  null
  
)

export default component.exports